import { Layout } from "@/modules/DashboardTemplate/models/Layout";

export const DEFAULT_LAYOUT: Layout = {
  x: 0,
  y: 0,
  width: 250,
  height: 94
};

export function normalizeLayout(
  layout?: Layout,
  defaults: Partial<Layout> = DEFAULT_LAYOUT,
  widthMax?: number
) {
  const base: Layout = {
    ...DEFAULT_LAYOUT,
    ...defaults,
    ...layout
  };
  if (widthMax) {
    base.width = base.width > widthMax ? widthMax : base.width;
  }

  return {
    ...base,
    x: Math.max(0, base.x),
    y: Math.max(0, base.y)
  };
}
